import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { DocumentDownloadOptions, ReferencesDict } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface ExportKimToWordParams {
  title: string;
  content: string;
  references?: ReferencesDict;
  options?: Partial<DocumentDownloadOptions>;
}

export const useExportKimToWord = (matterId?: string, subsetId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation(
    async ({ title, content, references, options }: ExportKimToWordParams) => {
      const hasReferences = references && Object.keys(references).length > 0;

      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: {
          title,
          content,
          ...(hasReferences && { references }),
          ...(options && { options }),
        },
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/export`,
        fetchConfig,
      );

      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${title}.docx`;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    {
      onError: () => {
        toast.error('Failed to download as Word document');
      },
    },
  );
};
